// Mock data for Bharatanatyam dancer website

export const artistInfo = {
  name: "Digjaya Ghaisas",
  tagline: "Where rhythm meets devotion, and movement tells timeless stories",
  bio: `Digjaya Ghaisas is a distinguished Bharatanatyam artist with over 15 years of dedicated practice and performance. Trained under the legendary Guru Padma Subrahmanyam and later under Smt. Lakshmi Viswanathan, she has completed her Arangetram at the prestigious Narada Gana Sabha in Chennai.

Her performances are marked by a deep understanding of abhinaya (expression) and intricate nritta (pure dance), blending traditional repertoire with contemporary interpretations. She has performed at major festivals including Margazhi Festival Chennai, Khajuraho Dance Festival, and various international stages across USA, UK, and Singapore.

Digjaya holds a Master's degree in Performing Arts from Kalakshetra Foundation and has received several accolades including the Youth Excellence Award from Natya Kala Conference and the Nritya Shiromani title.`,
  training: "Kalakshetra Foundation, Chennai",
  gurus: ["Guru Padma Subrahmanyam", "Smt. Lakshmi Viswanathan"],
  experience: "15+ years",
  awards: [
    "Youth Excellence Award - Natya Kala Conference (2019)",
    "Nritya Shiromani - Indian Fine Arts Society (2021)",
    "Best Abhinaya Performance - Margazhi Festival (2022)"
  ],
  philosophy: "Dance is not just movement; it is a sacred conversation between the soul and the divine. Through Bharatanatyam, I seek to preserve our rich cultural heritage while making it accessible and relevant to contemporary audiences."
};

export const performanceVideos = [
  {
    id: 1,
    title: "Ma mavasada janani | Digjaya Ghaisas",
    description: "Traditional opening piece in Adi Talam, showcasing pure nritta elements",
    videoUrl: "https://www.youtube.com/embed/gALUMlDL7FY",
    category: "Traditional Repertoire",
    thumbnail: "https://images.unsplash.com/photo-1764014792666-0f9e3c8442a9?w=800&q=80"
  },
  {
    id: 2,
    title: "Vandeham Sharada | Bharatanatyam",
    description: "Centerpiece varnam depicting the devotion of Andal to Lord Ranganatha",
    videoUrl: "https://www.youtube.com/embed/CTWqwNUkuSA",
    category: "Traditional Repertoire",
    thumbnail: "https://images.unsplash.com/photo-1722440044170-8df784901428?w=800&q=80"
  },
  {
    id: 3,
    title: "Ashadhi Ekadashi 2025 | Bharatanatyam Abhanga – \"Jaganyache Deva Aise Dyave Bal\"",
    description: "Devotional Abhanga performed on the auspicious occasion of Ashadhi Ekadashi",
    videoUrl: "https://www.youtube.com/embed/2ST_FHznj3o",
    category: "Abhinaya",
    thumbnail: "https://images.unsplash.com/photo-1717011969223-0217a302ec6f?w=800&q=80"
  },
  {
    id: 4,
    title: "Nobo Anande Jago | Rabindra Sangeet",
    description: "Expressive piece exploring the emotions of separation and longing",
    videoUrl: "https://www.youtube.com/embed/1GgkTdtckug",
    category: "Abhinaya",
    thumbnail: "https://images.unsplash.com/photo-1756370256926-e48ca54c5efe?w=800&q=80"
  },
  {
    id: 5,
    title: "Abhang - Khel Mandiyela",
    description: "Light classical piece showcasing the nayika's playful emotions",
    videoUrl: "https://www.youtube.com/embed/IMEB3MAiOEI",
    category: "Abhinaya",
    thumbnail: "https://images.unsplash.com/photo-1764014792668-bc484714744f?w=800&q=80"
  },
  {
    id: 6,
    title: "Dhanashree Thillana | Agam | Bharatanatyam",
    description: "Full length performance at Chennai's prestigious Margazhi Festival",
    videoUrl: "https://www.youtube.com/embed/bLncHQeVgrc",
    category: "Live Performances",
    thumbnail: "https://images.unsplash.com/photo-1768491815837-87a90744f9e6?w=800&q=80"
  }
];

export const classSchedule = {
  beginner: {
    level: "Beginner",
    description: "For students new to Bharatanatyam. Focus on basic adavus, aramandi, and introductory theory.",
    duration: "60 minutes per session",
    schedule: [
      { day: "Tuesday", time: "6:00 PM - 7:00 PM", mode: "In-person" },
      { day: "Thursday", time: "6:00 PM - 7:00 PM", mode: "In-person" }
    ]
  },
  intermediate: {
    level: "Advanced",
    description: "For students who have completed basic training. Advanced adavus, jatis, and simple compositions.",
    duration: "60 minutes per session",
    schedule: [
      { day: "Tuesday", time: "5:00 PM - 6:00 PM", mode: "In-person" },
      { day: "Thursday", time: "5:00 PM - 6:00 PM", mode: "In-person" }
    ]
  }
};

export const contactInfo = {
  email: "digjaya.ghaisas@gmail.com",
  phone: "+91 9820751189",
  socialMedia: {
    instagram: "https://www.instagram.com/nrityavilasini/",
    youtube: "https://youtube.com/@digjayabharatanatyam",
    facebook: "https://www.facebook.com/digjaya.ghaisas"
  }
};
